// API Configuration
// Automatically detects environment and provides correct API base URL



// In development, use localhost:3001
// In production, API is served from the same origin
export const API_BASE_URL = '';

// API Endpoints
export const API_ENDPOINTS = {
  // Public endpoints
  appointments: `${API_BASE_URL}/api/appointments`,
  contact: `${API_BASE_URL}/api/contact`,
  newsletter: `${API_BASE_URL}/api/newsletter`,
  health: `${API_BASE_URL}/api/health`,

  // Admin endpoints
  admin: {
    login: `${API_BASE_URL}/api/admin/login`,
    logout: `${API_BASE_URL}/api/admin/logout`,
    check: `${API_BASE_URL}/api/admin/check`,
    submissions: `${API_BASE_URL}/api/admin/submissions`,
    deleteSubmission: (type: string, id: string) =>
      `${API_BASE_URL}/api/admin/submissions/${type}/${id}`,
  },
};

// Fetch options with credentials
export const fetchOptions = {
  credentials: 'include' as RequestCredentials,
  headers: {
    'Content-Type': 'application/json',
  },
};
